import React, { useState, useEffect, useCallback } from "react";

import ReactDOM from "react-dom";

import URL from "../../config/api";
import axios from "../../config/axios";

// ─── Ícones (SVG inline) ─────────────────────────────────────────────────────
const Icons = {
  Clock: () => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Target: () => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  Print: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 9V2h12v7" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
      <path d="M6 14h12v8H6z" />
    </svg>
  ),
  Link: () => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
    </svg>
  ),
  Book: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </svg>
  ),
  Loader: () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ animation: "spin 1s linear infinite" }}
    >
      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" />
      <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" />
      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="18" y1="12" x2="22" y2="12" />
      <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" />
      <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" />
    </svg>
  ),
  X: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  )
};

// ─── Cores das sessões ───────────────────────────────────────────────────────
const SESSION_COLORS = [
  { bg: "#EEEDFE", text: "#3C3489", accent: "#7F77DD" },
  { bg: "#E1F5EE", text: "#085041", accent: "#1D9E75" },
  { bg: "#FAEEDA", text: "#633806", accent: "#BA7517" },
  { bg: "#FBEAF0", text: "#72243E", accent: "#D4537E" },
  { bg: "#E6F1FB", text: "#0C447C", accent: "#378ADD" }
];

const HEADER_GRADIENTS = [
  "linear-gradient(135deg, #7F77DD 0%, #1D9E75 100%)",
  "linear-gradient(135deg, #378ADD 0%, #7F77DD 100%)",
  "linear-gradient(135deg, #1D9E75 0%, #378ADD 100%)",
  "linear-gradient(135deg, #D4537E 0%, #BA7517 100%)",
  "linear-gradient(135deg, #BA7517 0%, #D85A30 100%)"
];

function getGradient(habilidades = []) {
  const code = habilidades[0] || "";
  const num = parseInt(code.replace(/\D/g, "").slice(-2)) || 0;
  return HEADER_GRADIENTS[num % HEADER_GRADIENTS.length];
}

// ─── Componente de uma sessão (otimizado para impressão) ────────────────────
function SessionCard({ sessao, index }) {
  const color = SESSION_COLORS[index % SESSION_COLORS.length];

  const extractQuote = text => {
    const match = text.match(/['"'"]([^'"'"]{20,})['"'"]/);
    return match ? match[1] : null;
  };

  const quote = extractQuote(sessao.texto);
  const mainText = quote
    ? sessao.texto.replace(/\s*['"'"][^'"'"]{20,}['"'"]\s*\.?/, "").trim()
    : sessao.texto;

  return (
    <div
      className="session-card"
      style={{ ...styles.sessionCard, breakInside: "avoid" }}
    >
      <div style={{ ...styles.sessionAccentBar, background: color.accent }} />
      <div style={styles.sessionContent}>
        <div style={styles.sessionHeader}>
          <div style={styles.sessionHeaderLeft}>
            <span
              className="session-badge"
              style={{
                ...styles.sessionBadge,
                background: color.bg,
                color: color.text
              }}
            >
              {index + 1}
            </span>
            <span style={styles.sessionTitle}>{sessao.titulo}</span>
          </div>
          <div style={styles.sessionHeaderRight}>
            <span
              style={{
                ...styles.durationChip,
                background: color.bg,
                color: color.text
              }}
            >
              <Icons.Clock /> {sessao.duracao} min
            </span>
          </div>
        </div>
        <div style={styles.sessionBody}>
          <div style={styles.divider} />
          <p style={styles.sessionText}>{mainText}</p>
          {quote && (
            <div
              style={{
                ...styles.quoteBox,
                background: "#FAEEDA",
                borderColor: "#BA7517"
              }}
            >
              <span style={styles.quoteIcon}>💬</span>
              <p style={{ ...styles.quoteText, color: "#633806" }}>«{quote}»</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Conteúdo do plano de aula (com melhorias para impressão) ───────────────
function LessonPlanContent({ plan }) {
  const gradient = getGradient(plan.habilidades_bncc || []);
  const totalDuracao =
    plan.aulas?.[0]?.sessoes?.reduce((s, x) => s + (x.duracao || 0), 0) ||
    plan.duracao ||
    0;

  return (
    <div className="plan-wrapper" style={styles.planWrapper}>
      <div
        style={{ ...styles.header, background: gradient }}
        className="plan-header"
      >
        <div style={styles.headerDecoCircle1} />
        <div style={styles.headerDecoCircle2} />
        <div className="header-chips" style={styles.headerChips}>
          {plan.habilidades_bncc?.map(h => (
            <span key={h} style={styles.headerChip}>
              {h}
            </span>
          ))}
          <span style={styles.headerChip}>1º Ano EF</span>
          <span style={styles.headerChip}>
            <Icons.Clock /> {totalDuracao} min
          </span>
          {plan.aprofundamento && (
            <span style={styles.headerChip}>{plan.aprofundamento}</span>
          )}
        </div>
        <h1 style={styles.headerTitle}>{plan.titulo}</h1>
        {plan.objetivo_aprendizagem && (
          <div style={styles.objetivoRow}>
            <Icons.Target />
            <p style={styles.objetivoText}>{plan.objetivo_aprendizagem}</p>
          </div>
        )}
      </div>

      <div style={styles.body}>
        {plan.aulas?.map((aula, ai) => (
          <div key={aula.id ?? ai} className="aula-wrapper">
            {plan.aulas.length > 1 && (
              <div style={styles.aulaLabel}>
                <span style={styles.aulaLabelText}>
                  Aula {aula.id ?? ai + 1}
                </span>
              </div>
            )}
            {/* Barra de tempo */}
            <div className="timeline-row" style={styles.timelineRow}>
              {aula.sessoes?.map((s, si) => {
                const color = SESSION_COLORS[si % SESSION_COLORS.length];
                const pct = totalDuracao
                  ? Math.round((s.duracao / totalDuracao) * 100)
                  : 0;
                return (
                  <div
                    key={si}
                    title={`${s.titulo} — ${s.duracao} min`}
                    style={{
                      ...styles.timelineSegment,
                      width: `${pct}%`,
                      background: color.accent,
                      opacity: 0.85
                    }}
                  />
                );
              })}
            </div>
            <div className="timeline-labels" style={styles.timelineLabels}>
              {aula.sessoes?.map((s, si) => {
                const color = SESSION_COLORS[si % SESSION_COLORS.length];
                const pct = totalDuracao
                  ? Math.round((s.duracao / totalDuracao) * 100)
                  : 0;
                return (
                  <div
                    key={si}
                    style={{ width: `${pct}%`, textAlign: "center" }}
                  >
                    <span
                      style={{
                        ...styles.timelineDot,
                        background: color.accent
                      }}
                    />
                    <span style={styles.timelineMinLabel}>{s.duracao}′</span>
                  </div>
                );
              })}
            </div>

            <div className="sessions-list" style={styles.sessionsList}>
              {aula.sessoes?.map((sessao, si) => (
                <SessionCard key={si} sessao={sessao} index={si} />
              ))}
            </div>
          </div>
        ))}

        {plan.referencia?.length > 0 && (
          <div className="ref-section" style={styles.refSection}>
            <p style={styles.refSectionTitle}>
              <Icons.Book /> Materiais de referência
            </p>
            <div style={styles.refList}>
              {plan.referencia.map((ref, i) => (
                <a
                  key={i}
                  href={ref.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.refCard}
                >
                  <div style={styles.refCardLeft}>
                    <Icons.Link />
                  </div>
                  <div>
                    <span style={styles.refCardType}>{ref.tipo}</span>
                    <span style={styles.refCardTitle}>{ref.titulo}</span>
                  </div>
                  <span style={styles.refCardArrow}>→</span>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Modal principal com portal e botão de imprimir ─────────────────────────
export default function LessonPlanModal({
  isOpen,
  onClose,
  lessonPlanId,
  userToken
}) {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLessonPlan = useCallback(
    async id => {
      if (!id) return;
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${URL.api}education/lesson-plans/${id}`,
          {
            headers: { Authorization: `Bearer ${userToken}` }
          }
        );
        const planData =
          response.data.data?.json_lesson_plans || response.data.data;
        setPlan(planData);
      } catch (err) {
        setError(
          err.response?.data?.message || "Erro ao carregar plano de aula"
        );
      } finally {
        setLoading(false);
      }
    },
    [userToken]
  );

  useEffect(() => {
    if (isOpen && lessonPlanId) fetchLessonPlan(lessonPlanId);
  }, [isOpen, lessonPlanId, fetchLessonPlan]);

  // Estilos globais só enquanto o modal está aberto (ver GLOBAL_STYLE_CONTENT).
  useEffect(() => {
    if (!isOpen) return undefined;

    document.querySelector(`#${GLOBAL_STYLE_ID}`)?.remove();

    const globalStyle = document.createElement("style");
    globalStyle.id = GLOBAL_STYLE_ID;
    globalStyle.textContent = GLOBAL_STYLE_CONTENT;
    document.head.appendChild(globalStyle);

    return () => globalStyle.remove();
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const modalContainer = document.querySelector(
          ".lesson-plan-modal-container"
        );
        if (modalContainer) modalContainer.focus();
      }, 100);
    }
  }, [isOpen]);

  const handlePrint = () => window.print();

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="lesson-plan-modal-overlay"
      onClick={onClose}
      style={styles.overlay}
    >
      <div
        className="lesson-plan-modal-container"
        id="lesson-plan-print"
        onClick={e => e.stopPropagation()}
        style={styles.modal}
        tabIndex={-1}
      >
        <button
          className="modal-close-btn"
          onClick={onClose}
          style={styles.closeBtn}
          aria-label="Fechar"
        >
          <Icons.X />
        </button>
        <button
          className="modal-print-btn"
          onClick={handlePrint}
          style={styles.printBtn}
          aria-label="Imprimir"
        >
          <Icons.Print />
        </button>
        <div style={styles.modalBody}>
          {loading && (
            <div style={styles.stateCenter}>
              <div style={{ color: "#7F77DD" }}>
                <Icons.Loader />
              </div>
              <p style={styles.stateText}>Carregando plano de aula...</p>
            </div>
          )}
          {error && (
            <div style={styles.stateCenter}>
              <p style={{ fontSize: 32 }}>⚠️</p>
              <p style={{ ...styles.stateText, color: "#A32D2D" }}>{error}</p>
              <button
                onClick={() => fetchLessonPlan(lessonPlanId)}
                style={styles.retryBtn}
              >
                Tentar novamente
              </button>
            </div>
          )}
          {!loading && !error && plan && <LessonPlanContent plan={plan} />}
          {!loading && !error && !plan && (
            <div style={styles.stateCenter}>
              <p style={styles.stateText}>Nenhum plano disponível.</p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

// ─── Estilos (objeto CSS) ────────────────────────────────────────────────────
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "80px 16px 24px",
    backdropFilter: "blur(2px)",
    overflowY: "auto"
  },
  modal: {
    position: "relative",
    background: "#F7F6F2",
    borderRadius: "18px",
    width: "100%",
    maxWidth: "720px",
    boxShadow: "0 24px 64px rgba(0,0,0,0.22)",
    marginBottom: "24px"
  },
  closeBtn: {
    position: "absolute",
    top: 14,
    right: 14,
    zIndex: 10,
    background: "rgba(255,255,255,0.85)",
    border: "none",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#444",
    backdropFilter: "blur(4px)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)"
  },
  printBtn: {
    position: "absolute",
    top: 14,
    right: 60,
    zIndex: 10,
    background: "rgba(255,255,255,0.85)",
    border: "none",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#444",
    backdropFilter: "blur(4px)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)"
  },
  modalBody: {},
  stateCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "260px",
    gap: "12px"
  },
  stateText: { fontSize: "15px", color: "#666", textAlign: "center" },
  retryBtn: {
    marginTop: "8px",
    padding: "8px 20px",
    background: "#EEEDFE",
    color: "#3C3489",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer"
  },
  planWrapper: { display: "flex", flexDirection: "column" },
  header: {
    padding: "32px 28px 24px",
    position: "relative",
    overflow: "hidden",
    borderRadius: "18px 18px 0 0"
  },
  headerDecoCircle1: {
    position: "absolute",
    top: -50,
    right: -50,
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.07)",
    pointerEvents: "none"
  },
  headerDecoCircle2: {
    position: "absolute",
    bottom: -40,
    left: 20,
    width: 130,
    height: 130,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.05)",
    pointerEvents: "none"
  },
  headerChips: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginBottom: "14px",
    position: "relative"
  },
  headerChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "11px",
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.2)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.25)",
    letterSpacing: "0.03em"
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: 800,
    color: "#fff",
    lineHeight: 1.25,
    margin: "0 0 12px",
    position: "relative"
  },
  objetivoRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "7px",
    position: "relative"
  },
  objetivoText: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.88)",
    lineHeight: 1.6,
    margin: 0
  },
  body: { padding: "20px 24px 28px" },
  aulaLabel: { marginBottom: "10px" },
  aulaLabelText: {
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: "#888"
  },
  timelineRow: {
    display: "flex",
    borderRadius: "6px",
    overflow: "hidden",
    height: "8px",
    marginBottom: "4px",
    gap: "2px"
  },
  timelineSegment: { height: "100%", borderRadius: "4px" },
  timelineLabels: { display: "flex", marginBottom: "16px" },
  timelineDot: {
    display: "inline-block",
    width: 5,
    height: 5,
    borderRadius: "50%",
    marginRight: 3,
    verticalAlign: "middle"
  },
  timelineMinLabel: { fontSize: "10px", color: "#999" },
  sessionsList: { display: "flex", flexDirection: "column", gap: "8px" },
  sessionCard: {
    display: "flex",
    background: "#fff",
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid rgba(0,0,0,0.08)",
    breakInside: "avoid"
  },
  sessionAccentBar: { width: "4px", flexShrink: 0 },
  sessionContent: { flex: 1 },
  sessionHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 14px",
    gap: "8px"
  },
  sessionHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flex: 1,
    minWidth: 0
  },
  sessionHeaderRight: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexShrink: 0
  },
  sessionBadge: {
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 800,
    flexShrink: 0
  },
  sessionTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#1A1A18",
    wordBreak: "break-word"
  },
  durationChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "11px",
    fontWeight: 700,
    padding: "3px 8px",
    borderRadius: "20px"
  },
  sessionBody: { padding: "0 14px 14px" },
  divider: {
    height: "1px",
    background: "rgba(0,0,0,0.07)",
    marginBottom: "12px"
  },
  sessionText: { fontSize: "13px", color: "#555", lineHeight: 1.75, margin: 0 },
  quoteBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    borderLeft: "3px solid"
  },
  quoteIcon: { fontSize: "14px", flexShrink: 0, marginTop: "1px" },
  quoteText: {
    fontSize: "13px",
    fontStyle: "italic",
    lineHeight: 1.6,
    margin: 0
  },
  refSection: {
    marginTop: "24px",
    padding: "16px",
    background: "#fff",
    borderRadius: "12px",
    border: "1px solid rgba(0,0,0,0.08)"
  },
  refSectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: "#888",
    margin: "0 0 10px"
  },
  refList: { display: "flex", flexDirection: "column", gap: "6px" },
  refCard: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 12px",
    background: "#E6F1FB",
    borderRadius: "8px",
    textDecoration: "none"
  },
  refCardLeft: { color: "#0C447C", flexShrink: 0 },
  refCardType: {
    display: "block",
    fontSize: "10px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "#378ADD",
    marginBottom: "2px"
  },
  refCardTitle: {
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
    color: "#0C447C"
  },
  refCardArrow: {
    marginLeft: "auto",
    color: "#378ADD",
    fontSize: "16px",
    flexShrink: 0
  }
};

const GLOBAL_STYLE_ID = "lesson-plan-modal-styles";

/* Estilos globais do modal, incluindo a regra de impressão que esconde tudo o
   que está fora dele.

   Ficam num <style> injetado enquanto o modal está ABERTO e removido quando ele
   fecha — antes eram injetados no import do módulo, e a regra `body *` valia
   para sempre: qualquer window.print() em qualquer tela do AVA (relatórios,
   listas) saía em branco depois que uma página de conteúdo era visitada. */
const GLOBAL_STYLE_CONTENT = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @media print {
    /* Oculta tudo que está fora do modal */
    body *:not(.lesson-plan-modal-overlay):not(.lesson-plan-modal-overlay *) {
      display: none !important;
    }
    .lesson-plan-modal-overlay {
      position: relative !important;
      background: white !important;
      padding: 0 !important;
      margin: 0 !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
      backdrop-filter: none !important;
      display: block !important;
    }
    .lesson-plan-modal-container {
      position: relative !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      background: white !important;
      box-shadow: none !important;
      border-radius: 0 !important;
    }
    .modal-close-btn, .modal-print-btn {
      display: none !important;
    }
    .session-card, .refCard {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .timeline-row {
      margin: 10px 0;
    }
    @page {
      size: A4;
      margin: 1.5cm;
    }
  }
`;
